import { CircleCheckFilledIcon } from "@pharaday/lighthouse";

const StepSentLinkSuccessNotification = () => {
  return (
    <div className="mt-3 flex flex-col items-start">
      <CircleCheckFilledIcon className="mb-6 h-12 w-12 text-success-70" />
      <h1 className="text-2xl">Email sent</h1>
      <p className="mb-6 text-base text-neutral-variant-30/60">
        Check your email and open the link we sent to continue
      </p>
    </div>
  );
};

export default StepSentLinkSuccessNotification;
